import React from 'react'
import {
  sendTrackingEvent,
  toButtonEvent
} from '../../../services/amplitude.service'

import { FormComponentProps } from '../../FormContainer/types'
import { PromoCodeComponent } from './PromoCode.component'
import { PromoCodeValues, SkipButtonEvent } from './types'

export const PromoCodeContainer: React.FC<
  FormComponentProps<PromoCodeValues>
> = ({ formData, setFormData, navigateStep, error }) => {
  return (
    <>
      <PromoCodeComponent
        formData={formData}
        setFormData={setFormData}
        inValidCode={!!error}
        onSkip={() => {
          sendTrackingEvent(toButtonEvent({ ...SkipButtonEvent }))
          navigateStep()
        }}
      />
    </>
  )
}
